module.exports = __webpack_public_path__ + "static/img/Simon.Goodwin.8261b0b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Simon.Goodwin.jpg
// module id = gHfs
// module chunks = 0